{
  "common.close": "Закрыть",
  "common.athleteFallback": "спортсмен {id}",
  "splash.title": "{app} — анимированная визуализация активностей",
  "splash.tagline": "Ваши данные Strava&nbsp;в движении",
  "splash.demo": "Демо",
  "tab.query.title": "Карта: {name}",
  "tab.query.heading": "Запрос активностей:",
  "tab.query.optDays": "последние дни",
  "tab.query.optActivities": "последние активности",
  "tab.query.optIds": "ID активностей",
  "tab.query.optDates": "Диапазон дат",
  "tab.query.idsPlaceholder": "введите здесь ID активностей",
  "tab.query.after": "С:",
  "tab.query.before": "По:",
  "tab.query.autozoom": "После импорта автоматически приближать к запросу <i class=\"hf hf-bullseye\"></i>",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Запрос",
  "tab.query.createAccount": "Создайте аккаунт или войдите.",
  "tab.query.sports": "Виды спорта:",
  "tab.query.allSports": "Все виды спорта",
  "tab.query.sportsExcept": "Все, кроме",
  "tab.query.sportsNone": "Ничего",
  "tab.query.loadingSports": "Загрузка видов спорта…",
  "tab.query.sportsFailed": "Не удалось загрузить виды спорта этой карты",
  "tab.query.noSports": "Пока нет тренировок",
  "tab.activities.title": "Показанные активности",
  "tab.activities.clearSelection": "Снять выделение",
  "tab.activities.renderSelected": "Показать выбранное",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Приблизить к выделению",
  "tab.controls.title": "Настройки слоя",
  "tab.controls.timescale": "Масштаб времени <i>&tau;</i>",
  "tab.controls.timescaleHint": "скорость воспроизведения",
  "tab.controls.period": "Период <i>T</i>",
  "tab.controls.periodHint": "активность ~ модель",
  "tab.controls.dotSize": "Размер точек",
  "tab.controls.pathWidth": "Толщина линий",
  "tab.controls.pathWidthHint": "ноль скрывает линии",
  "tab.controls.colors": "Цвета",
  "tab.controls.colorsHint": "сдвиг палитры",
  "tab.controls.shadows": "Тени",
  "tab.profile.loginTitle": "Вход",
  "tab.profile.anonNote": "Войдите через Strava, чтобы видеть свои активности и управлять аккаунтом Heatflask.",
  "tab.profile.loginLink": "Войти через Strava",
  "tab.profile.editOnStrava": "Изменить профиль в Strava",
  "tab.profile.indexNote": "Мы индексируем сводки ваших активностей для быстрого доступа.",
  "tab.profile.viewIndex": "Открыть указатель",
  "tab.profile.sharedMaps": "Общий доступ к картам",
  "tab.profile.sharedMapsNote": "Выключено: ваши тренировки в Heatflask видите только вы. Включено: любой, у кого есть ссылка на вашу карту, увидит тренировки, которые вы открыли для всех в Strava. Приватные в любом случае останутся только вашими. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Как устроена приватность</a>",
  "tab.profile.logout": "Выйти",
  "tab.profile.deleteAccount": "Удалить аккаунт",
  "tab.profile.deleteConfirm": "Удалить ваш аккаунт Heatflask?\n\nЭто удалит проиндексированные активности и отзовёт доступ Heatflask к вашим данным в Strava. Отменить будет нельзя.",
  "tab.profile.languageHeading": "Язык",
  "tab.profile.languageAuto": "Автоматически",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Помогите исправить переводы или добавить новые!</a>",
  "tab.profile.unitsHeading": "Единицы",
  "tab.profile.unitsAuto": "Автоматически",
  "tab.profile.unitsMetric": "Метрические (км, м)",
  "tab.profile.unitsImperial": "Имперские (mi, ft)",
  "tab.profile.textSizeHeading": "Размер текста",
  "tab.profile.textSmaller": "Меньше",
  "tab.profile.textReset": "Обычный",
  "tab.profile.textLarger": "Больше",
  "tab.profile.mapDefaultsHeading": "Настройки карты по умолчанию",
  "tab.profile.mapDefaultsNote": "Начинать с этой подложки, рельефа и настроек слоя, когда вы открываете карту, ссылка на которую не задаёт своих. Ссылки, которыми вы делитесь, по-прежнему показывают ровно то, что видите вы.",
  "tab.profile.mapDefaultsSave": "Сохранить как мои настройки по умолчанию",
  "tab.profile.mapDefaultsForget": "Забыть",
  "tab.info.title": "Справка",
  "tab.info.controlsHeading": "Управление",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + перетаскивание",
  "tab.info.shiftDragDesc": "Выделить активности рамкой. На сенсорном экране сначала коснитесь <i class=\"hf-object-group\"></i>, затем ведите одним пальцем. У последней выбранной активности откроются подробности, а список прокрутится к ней.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + перетаскивание",
  "tab.info.ctrlDragDesc": "Поворот и наклон карты в 3D, либо двумя пальцами",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Открыть или закрыть боковую панель",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Предыдущая или следующая вкладка",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Закрыть боковую панель",
  "tab.info.liveUrlHeading": "Живая ссылка",
  "tab.info.liveUrlDesc": "Вид карты и настройки анимации хранятся в адресе страницы, поэтому тот, с кем вы поделитесь ссылкой, увидит ровно то же самое.",
  "tab.info.videoHeading": "Экспорт видео",
  "tab.info.videoDesc": "Кнопка <i class=\"hf-video-camera\"></i> записывает анимацию в MP4: коснитесь её, наведите рамку на нужную часть карты и коснитесь снова, чтобы начать запись. Записывается полный цикл анимации, поэтому видео повторяется без стыка; цикл длиннее {max} секунд (самое длинное видео, которое принимает Strava) обрезается на {max}.",
  "tab.info.contributeHeading": "Помочь проекту",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Стать спонсором на GitHub",
  "tab.info.contactsHeading": "Контакты",
  "map.basemapAndTerrain": "Подложка и рельеф",
  "map.pauseAnimation": "Приостановить анимацию",
  "map.resumeAnimation": "Продолжить анимацию",
  "capture.record": "Записать видео (цикл {period} с)",
  "capture.recordTruncated": "Записать видео (цикл длится {period} с; будут записаны только первые {max} с)",
  "capture.recordArea": "Записать область внутри рамки",
  "capture.stop": "Остановить запись",
  "capture.selectionTooSmall": "выделение слишком мало",
  "capture.saved": "{name} сохранён ({size})",
  "capture.cancelled": "запись отменена",
  "capture.failed": "не удалось записать: {error}",
  "capture.loadingEncoder": "загрузка кодировщика…",
  "capture.waitingForMap": "ожидание загрузки карты…",
  "capture.encoding": "кодирование… {percent} %",
  "capture.finalizing": "завершение…",
  "share.title": "Поделиться ссылкой на эту карту",
  "share.copied": "ссылка скопирована",
  "share.copiedUnshared": "ссылка скопирована, но общий доступ к вашей карте выключен, поэтому никто другой её не откроет. Включите «Общий доступ к картам», чтобы это изменить.",
  "share.unshared": "Общий доступ к вашей карте выключен, поэтому никто другой не откроет эту ссылку. Включите «Общий доступ к картам», чтобы это изменить.",
  "share.copyThis": "Скопируйте эту ссылку:",
  "update.available": "Доступна новая версия Heatflask.",
  "update.reload": "Перезагрузить",
  "import.title": "Импорт",
  "import.stop": "Стоп",
  "import.stopping": "останавливаем…",
  "import.contacting": "подключение к Strava…",
  "import.countOf": "Активности: {received} из {total}",
  "import.count": "Активности: {received}",
  "import.waitStrava": "Пауза до {time} из-за лимита загрузок Strava. Не закрывайте страницу; перезагрузка не ускорит.",
  "import.waitRationed": "Быстрые загрузки на сегодня израсходованы. Остальное продолжится в {time}, медленнее. Не закрывайте страницу.",
  "import.dailyLimit": "Дневной лимит загрузок Strava исчерпан. Попробуйте снова после {time}.",
  "import.dailyRationed": "Ваша доля загрузок из Strava на сегодня израсходована. Попробуйте снова после {time}.",
  "import.noActivitiesYet": "В вашем аккаунте Strava пока нет активностей. Запишите или загрузите одну в Strava, и она появится здесь.",
  "table.noActivities": "нет активностей",
  "table.untitled": "(без названия)",
  "activities.pageTitle": "{app} — указатель активностей",
  "activities.heading": "Указатель активностей",
  "activities.fetching": "Загрузка активностей...",
  "activities.rateLimit": "Достигнут лимит запросов Strava; продолжим в {time}",
  "activities.noData": "Данных нет &#128577;",
  "activities.colServerCache": "Трек закеширован на сервере (Mongo)",
  "activities.colBrowserCache": "Трек закеширован в этом браузере",
  "activities.cachedServer": "Трек {id} закеширован на сервере",
  "activities.notCachedServer": "Трек {id} не закеширован на сервере",
  "activities.cachedBrowser": "Трек {id} закеширован в этом браузере",
  "activities.notCachedBrowser": "Трек {id} не закеширован в этом браузере",
  "sport.AlpineSki": "Горные лыжи",
  "sport.BackcountrySki": "Ски-тур",
  "sport.Badminton": "Бадминтон",
  "sport.Basketball": "Баскетбол",
  "sport.Canoeing": "Каноэ",
  "sport.Cricket": "Крикет",
  "sport.Crossfit": "Кроссфит",
  "sport.Dance": "Танцы",
  "sport.EBikeRide": "Заезд на электровелосипеде",
  "sport.Elliptical": "Эллипсоид",
  "sport.EMountainBikeRide": "Заезд на электро-МТБ",
  "sport.Golf": "Гольф",
  "sport.GravelRide": "Гревел-заезд",
  "sport.Handcycle": "Хендбайк",
  "sport.HighIntensityIntervalTraining": "ВИИТ",
  "sport.Hike": "Поход",
  "sport.IceSkate": "Коньки",
  "sport.InlineSkate": "Ролики",
  "sport.Kayaking": "Каякинг",
  "sport.Kitesurf": "Кайтсерфинг",
  "sport.MountainBikeRide": "Заезд на МТБ",
  "sport.NordicSki": "Беговые лыжи",
  "sport.Padel": "Падел",
  "sport.PhysicalTherapy": "Физиотерапия",
  "sport.Pickleball": "Пиклбол",
  "sport.Pilates": "Пилатес",
  "sport.Racquetball": "Рэкетбол",
  "sport.Ride": "Велозаезд",
  "sport.RockClimbing": "Скалолазание",
  "sport.RollerSki": "Лыжероллеры",
  "sport.Rowing": "Гребля",
  "sport.Run": "Бег",
  "sport.Sail": "Парусный спорт",
  "sport.Skateboard": "Скейтборд",
  "sport.Snowboard": "Сноуборд",
  "sport.Snowshoe": "Снегоступы",
  "sport.Soccer": "Футбол",
  "sport.Squash": "Сквош",
  "sport.StairStepper": "Степпер",
  "sport.StandUpPaddling": "Сап-бординг",
  "sport.Surfing": "Сёрфинг",
  "sport.Swim": "Плавание",
  "sport.TableTennis": "Настольный теннис",
  "sport.Tennis": "Теннис",
  "sport.TrailRun": "Трейлраннинг",
  "sport.Velomobile": "Веломобиль",
  "sport.VirtualRide": "Виртуальный велозаезд",
  "sport.VirtualRow": "Виртуальная гребля",
  "sport.VirtualRun": "Виртуальный бег",
  "sport.Volleyball": "Волейбол",
  "sport.Walk": "Ходьба",
  "sport.WeightTraining": "Силовая тренировка",
  "sport.Wheelchair": "Инвалидная коляска",
  "sport.Windsurf": "Виндсёрфинг",
  "sport.Workout": "Тренировка",
  "sport.Yoga": "Йога"
}
